/* Speedconsultants — course player */
(function () {
  function init(root) {
    if (root.dataset.scsInit) return;
    root.dataset.scsInit = '1';

    var video = root.querySelector('video');
    var cover = root.querySelector('.scs-player-cover');
    var fill  = root.querySelector('.scs-buffer-fill');
    var hls   = root.getAttribute('data-hls');
    var mp4   = root.getAttribute('data-mp4');
    var wired = false;

    function chooseSource() {
      if (wired) return;
      wired = true;
      var canHls = hls && video.canPlayType('application/vnd.apple.mpegurl');
      if (canHls) { video.src = hls; }
      else if (mp4) { video.src = mp4; }
      else if (hls) { video.src = hls; }
      video.load();
    }

    function buffered() {
      if (!video.duration || !video.buffered.length) return;
      var end = video.buffered.end(video.buffered.length - 1);
      if (fill) fill.style.width = Math.min(100, (end / video.duration) * 100).toFixed(1) + '%';
    }

    function fail(msg) {
      root.classList.remove('is-buffering');
      if (cover) cover.hidden = false;
      console.error('[scs-player]', msg, { hls: hls, mp4: mp4, src: video.currentSrc });
    }

    if (cover) {
      cover.addEventListener('click', function () {
        chooseSource();
        cover.hidden = true;
        root.classList.add('is-buffering');
        var p = video.play();
        if (p && p.catch) p.catch(function (e) { fail('play() rejected: ' + e.name); });
      });
    }

    video.addEventListener('waiting',  function () { root.classList.add('is-buffering'); });
    video.addEventListener('playing',  function () { root.classList.remove('is-buffering'); });
    video.addEventListener('canplay',  function () { root.classList.remove('is-buffering'); });
    video.addEventListener('progress', buffered);
    video.addEventListener('loadedmetadata', buffered);
    video.addEventListener('error', function () {
      var c = video.error ? video.error.code : '?';
      fail('media error code ' + c);
    });
  }

  function boot() { document.querySelectorAll('[data-scs-player]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();